import {Link} from "react-router-dom";
import React, {Fragment, useEffect, useState} from "react";
import {getParams, useOuterClick} from "../../utils/hooks/getParams";
import {getClientsTransactions, getClientTransactions, updateTransaction} from "../../actions/clients_transaction";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment/moment";
import ClientDataCell from "./ClientDataCell";
import {formatMoney, unformatMoney} from "../../utils/hooks/getParams";

const ClientDataRow = ({index, item, resetAllRows}) => {
    const dispatch = useDispatch();

    const {
        auth
    } = useSelector(state => state);
    const {role_name} = auth?.user || {};

    const {
        updated_client_transaction
    } = useSelector(state => state.client);

    const [itemData, setItemData] = useState({
        transactions: []
    });
    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        setItemData(item);
    }, [item])

    useEffect(() => {
        if (updated_client_transaction)
            setItemData(updated_client_transaction);
    }, [updated_client_transaction])


    useEffect(() => {
        setRowData(itemData.transactions);
    }, [itemData]);

    const refreshRow = (id) => {
        dispatch(getClientTransactions(id));
    }


    const refreshPage = () => {
        window.location.reload();
    }

    return (
        <tr>
            <th className="sticky-col">{index + 1}</th>
            <th className="sticky-col2">
                <Link to={`clients/${itemData.id}`}>
                    {itemData.name}
                </Link>
            </th>
            {
                rowData.map((subitem, subindex) => (
                    <ClientDataCell
                        rowData={rowData}
                        key={subindex}
                        row_id={itemData.id}
                        item={subitem}
                        cellItem={subitem}
                        index={subindex}
                        setItemData={setItemData}
                        setRowData={setRowData}
                        refreshRow={refreshRow}
                        resetAllRows={() => console.log(2)}
                    />))
            }
            <th style={{textAlign: "center", minWidth: "100px", right: "300px"}}
                title={formatMoney(itemData.prev_month_left_amount)}
            >
                {formatMoney(itemData.prev_month_left_amount)}
            </th>
            <th style={{textAlign: "center", minWidth: "100px", right: "200px"}}
                title={formatMoney(itemData.transactions_sum_received_amount, ',')}
            >
                {formatMoney(itemData.transactions_sum_received_amount, ',')}
            </th>
            <th style={{textAlign: "center", minWidth: "100px", right: "100px"}}
                title={formatMoney(itemData.transactions_sum_paid_amount, ',')}
            >
                {formatMoney(itemData.transactions_sum_paid_amount, ',')}
            </th>
            <th style={{textAlign: "center", minWidth: "100px", right: "0px"}}
                title={formatMoney(itemData.current_month_left_amount)}
            >
                {formatMoney(itemData.current_month_left_amount)}
            </th>
        </tr>
    )
}

export default ClientDataRow;